import { Component, OnInit } from '@angular/core';
import { RequestService } from '../shared/request.service';
import { Type } from '../../programs/shared/type.model';
import { ActivatedRoute, Router } from '@angular/router';
import { StudentService } from '../../students/shared/student.service';
import { ProgramService } from '../../programs/shared/program.service';

@Component({
  selector: 'app-types',
  templateUrl: './types.component.html',
  styleUrls: ['./types.component.scss']
})
export class TypesComponent implements OnInit {
  typeSelect: string;
  types: Type[];
  messageError: String = '';
  program: number;
  version: number;

  constructor(private requetsService: RequestService, private route: ActivatedRoute,
              private router: Router, private studentService: StudentService,
              private programService: ProgramService) { }

  ngOnInit() {
    this.route
      .queryParams
      .subscribe(params => {
        const cedula = localStorage.getItem('cedula');
        this.program =  params['programa'];
        this.version =  params['version'];
        this.getValidateRequest(cedula, this.program, this.version);
      });
  }

  goback () {
    window.history.back();
  }

  sendToRequest() {
    if (this.typeSelect !== undefined) {
      this.router.navigate(['solicitudes/registro-asignaturas'], { queryParams: { programa: this.program , tipo: this.typeSelect } });
    } else {
      this.messageError = 'Debe seleccionar un tipo de solicitud';
    }

  }

  private getValidateRequest(cedula, programa, version) {
    this.studentService.getStudentRecords(cedula, programa, null).subscribe(
      (result) => {
        if (result.data === []) {
          this.validatePifleProgram(cedula, programa, version);
        } else {
          this.getTypeRequest(cedula, programa, version);
        }
      },
      (error) => {
          console.log(error);
      });
  }

  private validatePifleProgram(cedula, programa, version) {
    this.programService.isBelongPifle(programa, version).subscribe(
      (result) => {
        if (!result.data) {
          this.router.navigate(['solicitudes/registro-asignaturas'], { queryParams: { programa: programa } });
        } else {
          this.getTypeRequest(cedula, programa, version);
        }
      },
      (error) => {
          console.log(error);
      });
  }

  private getTypeRequest(cedula, programa, version) {
    this.requetsService.getTypeRequestAvailable(cedula, programa, version).subscribe(
      (result) => {
        if (result.data !== []) {
          this.types = result.data;
        }
      }
    );
  }



}
